function findPlayingTimelineIndexByVideoTimeRecursively(
  playingVideoTime,
  timelines,
  fromIndex,
  toIndex,
) {
  if (fromIndex === toIndex) {
    const pickedTimeline = timelines[fromIndex];
    if (playingVideoTime >= pickedTimeline.startVideoTime
      && playingVideoTime < pickedTimeline.endVideoTime) {
      return fromIndex;
    }
    // Invalid data!
    return -1;
  }

  const pickedIndex = Math.ceil((fromIndex + toIndex) / 2);
  const pickedTimeline = timelines[pickedIndex];
  if (!pickedTimeline) {
    // TODO: How this happen!
    return -1;
  }

  if (playingVideoTime < pickedTimeline.startVideoTime) {
    return findPlayingTimelineIndexByVideoTimeRecursively(
      playingVideoTime,
      timelines,
      fromIndex,
      pickedIndex - 1,
    );
  }

  return findPlayingTimelineIndexByVideoTimeRecursively(
    playingVideoTime,
    timelines,
    pickedIndex,
    toIndex,
  );
}

export function findPlayingTimelineIndexByVideoTime(
  playingVideoTime,
  timelines,
  latestPlayingTimelineIndex = -1,
) {
  if (timelines.length <= 0) {
    return -1;
  }

  if (latestPlayingTimelineIndex >= 0) {
    const latestPlayingTimeline = timelines[latestPlayingTimelineIndex];
    if (latestPlayingTimeline.startVideoTime <= playingVideoTime
      && playingVideoTime < latestPlayingTimeline.endVideoTime) {
      return latestPlayingTimeline;
    }
  }

  return findPlayingTimelineIndexByVideoTimeRecursively(
    playingVideoTime,
    timelines,
    0,
    timelines.length - 1,
  );
}

function findPlayingTimelineIndexByTimelineTimeRecursively(
  playingTimelineTime,
  timelines,
  fromIndex,
  toIndex,
) {
  if (fromIndex === toIndex) {
    const pickedTimeline = timelines[fromIndex];
    if (playingTimelineTime >= pickedTimeline.startTimelineTime
      && playingTimelineTime < pickedTimeline.endTimelineTime) {
      return fromIndex;
    }
    // Invalid data!
    return -1;
  }

  const pickedIndex = Math.ceil((fromIndex + toIndex) / 2);
  const pickedTimeline = timelines[pickedIndex];
  if (!pickedTimeline) {
    // TODO: How this happen!
    return -1;
  }

  if (playingTimelineTime < pickedTimeline.startTimelineTime) {
    return findPlayingTimelineIndexByTimelineTimeRecursively(
      playingTimelineTime,
      timelines,
      fromIndex,
      pickedIndex - 1,
    );
  }

  return findPlayingTimelineIndexByTimelineTimeRecursively(
    playingTimelineTime,
    timelines,
    pickedIndex,
    toIndex,
  );
}

export function findPlayingTimelineIndexByTimelineTime(
  playingTimelineTime,
  timelines,
  latestPlayingTimelineIndex = -1,
) {
  if (timelines.length <= 0) {
    return -1;
  }

  if (latestPlayingTimelineIndex >= 0) {
    const latestPlayingTimeline = timelines[latestPlayingTimelineIndex];
    if (latestPlayingTimeline.startTimelineTime <= playingTimelineTime
      && playingTimelineTime < latestPlayingTimeline.endTimelineTime) {
      return latestPlayingTimeline;
    }
  }

  return findPlayingTimelineIndexByTimelineTimeRecursively(
    playingTimelineTime,
    timelines,
    0,
    timelines.length - 1,
  );
}

export default {
  findPlayingTimelineIndexByVideoTime,
  findPlayingTimelineIndexByTimelineTime,
};
